import { Field, Input, Label } from '@innovationnorway/cl-react';
import React, { useMemo } from 'react';

import useUpdateQueryStringParam from 'src/features/one-way-in/opportunity-table/hooks/use-update-query-string-param';

type FilterProps = {
  queryStringParam: string;
  label: string;
};

const FilterDateInput = ({ queryStringParam, label }: FilterProps) => {
  const { searchParams, updateQueryStringParam } = useUpdateQueryStringParam();

  const { date } = useMemo(() => {
    return {
      date: searchParams.get(queryStringParam) ?? '',
    };
  }, [queryStringParam, searchParams]);

  function handleChangeDate(e: React.ChangeEvent<HTMLInputElement>) {
    updateQueryStringParam(queryStringParam, e.target.value, 'single');
  }

  return (
    <Field>
      <Label>{label}</Label>
      <Input
        type="date"
        name={queryStringParam}
        className={`margin-bottom--0 width--stretch`}
        value={date}
        onChange={handleChangeDate}
      />
    </Field>
  );
};

export default FilterDateInput;
